import { Router } from "wouter";
import App from "./App";
import { StructuredDataContext, type StructuredDataCollector } from "./hooks/useStructuredData";

// Keep the tree identical for build-time rendering and browser hydration (useId).
export default function Root({
  path,
  schemas,
}: {
  path?: string;
  schemas?: StructuredDataCollector;
}) {
  return (
    <Router ssrPath={path}>
      <StructuredDataContext.Provider value={schemas}>
        <App />
      </StructuredDataContext.Provider>
    </Router>
  );
}
